import React, { useEffect, useState, useRef } from 'react';
import { useVitals }   from '../contexts/VitalProvider';
import './ScanPage.scss';
import instVideo       from '../assets/inst_video.webm';
import { IoCloseSharp } from 'react-icons/io5';

export default function ScanPage() {              // ◄ onComplete prop no longer needed
  const vitals = useVitals();

  /* UI state */
  const [instrVisible, setInstr   ] = useState(true);
  const [capturing,    setCapturing] = useState(false);
  const reloadRef = useRef(false);

  /* boot the SDK once */
  useEffect(() => {
    window.bootScan?.();
    return () => {
      if (!reloadRef.current) window.stopScan?.();
    };
  }, []);

  useEffect(() => {
    const finish = () => {
      setTimeout(() => {
        reloadRef.current = true;           
        window.location.reload();
      }, 150);
    };

    window.addEventListener('scan-complete', finish);
    return () => window.removeEventListener('scan-complete', finish);
  }, []);

  const toggleCapture = () => {
    if (!capturing) {
      window.resetScanProgress?.();      
    }
    window.dispatchEvent(new Event('toggle-capture'));
    setCapturing(c => !c);
    if (!capturing) setInstr(false);
  };

  const progress = vitals.progressPercentage ?? 0;

  /* render */
  return (
    <div className="scan-wrapper">
      <video  className="video-stream" muted playsInline style={{display:'none'}} />
      <canvas className="scan-canvas"/>

      {instrVisible && (
        <div className="instruction">
          <button className="skip" onClick={() => setInstr(false)}>
            <IoCloseSharp/>
          </button>
          <div className="video-frame">
            <video src={instVideo} autoPlay loop muted/>
          </div>
        </div>
      )}

      <div className="progress" style={{opacity: capturing ? 1 : 0}}>
        <div
          className="bar"
          style={{
            backgroundImage: `linear-gradient(90deg,#20d472 ${progress}% ,#404040 ${progress}%)`
          }}
        />
      </div>

      <button
        className={`capture-btn ${capturing ? 'stop' : ''}`}
        onClick={toggleCapture}
      />
    </div>
  );
}
